import React from "react";
import {I18nMessage} from "assecobs-faktor-web-common/index";

export default ({labelKey, onClick}) => (
    <button type={onClick ? "button" : "submit"}
            className="btn btn-lg btn-type-d authentication-btn__submit"
            {...onClick && {onClick: onClick}}>
        <I18nMessage id={labelKey} />
    </button>
);
